document.addEventListener('change', function (e) {
  const select = e.target.closest('wr-facets-sort-select .sort-by-select');
  if (!select) return;

  const value = select.value;
  if (!value) return;

  const el = select.closest('wr-facets-sort-select');
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  url.searchParams.delete('page');
  url.searchParams.set('section_id', el.getAttribute('section-id'));

  el.dispatchEvent(
    new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url },
    })
  );
});
